export class listProvinceModel {
    codigo: string;
    descripcion: string;
}